(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["choix-support"] && !Shopify.designMode) return;
  try {
    /* Au changement de taille du sapin, le thème recharge la section pour la
     nouvelle variante (assets/variant-picker.js, évènement
     `shopify:product:select`, dont la promesse rend le HTML). Le choix des
     supports y est déjà filtré par Liquid : on reprend celui du même bloc,
     sans rien recalculer ici. Le support coché reste coché s'il convient
     encore ; sinon « Sans support » (un supplément payant ne se précoche
     pas). */
  if (!customElements.get('choix-support-component')) {
    customElements.define(
      'choix-support-component',
      class extends HTMLElement {
        connectedCallback() {
          this.conteneur = this.closest('.shopify-section, dialog, product-card');
          this.conteneur?.addEventListener('shopify:product:select', this.surChangement);
        }

        disconnectedCallback() {
          this.conteneur?.removeEventListener('shopify:product:select', this.surChangement);
        }

        surChangement = async (event) => {
          const resultat = await event.promise?.catch(() => null);
          const html = resultat?.detail?.html;
          if (!html) return;
          const nouveau = html.querySelector(`choix-support-component[data-bloc="${this.dataset.bloc}"]`);
          if (!nouveau) return;
          const coche = this.querySelector('input[type="radio"]:checked')?.value;
          this.innerHTML = nouveau.innerHTML;
          if (!coche) return;
          const radio = Array.from(this.querySelectorAll('input[type="radio"]')).find((r) => r.value === coche);
          if (radio) radio.checked = true;
        };
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sommaire"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sommaire-guide')) {
    customElements.define(
      'sommaire-guide',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.shopify-section');
          const liste = this.querySelector('.sommaire__liste');
          if (!section || !liste || liste.children.length) return;
          // Les titres QUI SUIVENT le sommaire dans sa section (sur une fiche
          // produit, il ouvre la partie sous l'achat) : pas ceux d'avant.
          const titres = Array.from(section.querySelectorAll('h2')).filter(
            (h) => !this.contains(h) && h.textContent.trim() && this.compareDocumentPosition(h) & Node.DOCUMENT_POSITION_FOLLOWING
          );
          const pris = new Set();
          for (const titre of titres) {
            if (!titre.id) {
              let base = titre.textContent.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
              let id = base;
              for (let n = 2; pris.has(id) || document.getElementById(id); n++) id = base + '-' + n;
              titre.id = id;
            }
            pris.add(titre.id);
            const lien = document.createElement('a');
            lien.className = 'sommaire__lien';
            lien.href = '#' + titre.id;
            lien.textContent = titre.textContent.trim();
            const item = document.createElement('li');
            item.append(lien);
            liste.append(item);
          }
          if (liste.children.length > 1) this.hidden = false;
          // La partie lue est la pastille pleine (comme la maquette) : celle
          // dont le titre a passé le haut de la fenêtre en dernier.
          const liens = Array.from(liste.querySelectorAll('a'));
          // Les flèches et les fondus suivent ce qui reste à voir de chaque côté.
          const fleches = Array.from(this.querySelectorAll('.sommaire__fleche'));
          const bords = () => {
            const avant = liste.scrollLeft > 1;
            const apres = liste.scrollLeft + liste.clientWidth < liste.scrollWidth - 1;
            fleches[0].hidden = !avant;
            fleches[1].hidden = !apres;
            liste.classList.toggle('sommaire__liste--avant', avant);
            liste.classList.toggle('sommaire__liste--apres', apres);
          };
          for (const fleche of fleches) {
            fleche.addEventListener('click', () => {
              liste.scrollBy({ left: Number(fleche.dataset.sens) * liste.clientWidth * 0.8, behavior: 'smooth' });
            });
          }
          liste.addEventListener('scroll', bords, { passive: true });
          new ResizeObserver(bords).observe(liste);
          let precedent = null;
          const marquer = () => {
            let courant = liens[0];
            for (const lien of liens) {
              const cible = document.getElementById(lien.hash.slice(1));
              if (cible && cible.getBoundingClientRect().top < window.innerHeight * 0.35) courant = lien;
            }
            for (const lien of liens) lien.setAttribute('aria-current', lien === courant ? 'true' : 'false');
            // La pastille de la partie lue, ramenée dans la rangée (on ne fait
            // défiler que la rangée, jamais la page).
            if (courant !== precedent) {
              precedent = courant;
              const item = courant.parentElement;
              const gauche = item.offsetLeft - liste.offsetLeft;
              if (gauche < liste.scrollLeft || gauche + item.offsetWidth > liste.scrollLeft + liste.clientWidth) {
                liste.scrollTo({ left: gauche - (liste.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
              }
            }
          };
          marquer();
          bords();
          window.addEventListener('scroll', marquer, { passive: true });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
